import React, {
  useCallback, useEffect, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Drawer, Tabs,
} from 'antd';
import { StarFilled, StarOutlined } from '@ant-design/icons';
import ABWorkReportFilterTab from './ABWorkReportFilterTab';
import {
  getSavedABWorkReportFilters,
  setFavoriteABWorkReportFilter,
} from '../../abWorkReporting/state/abWorkReporting.actions';

const { TabPane } = Tabs;

export default function ABWorkReportFilterDrawer({
  visible,
  onClose,
  filters,
  setFilters,
  columns = [],
}) {
  const dispatch = useDispatch();
  const savedFilters = useSelector((state) => state.abWorkReporting.savedFilters);
  const [activeTab, setActiveTab] = useState('custom');

  useEffect(() => {
    dispatch(getSavedABWorkReportFilters());
  }, []);

  const onTabChange = useCallback((key) => {
    setActiveTab(key);
  }, []);

  const onToggleFavorite = useCallback((e, filter) => {
    e.stopPropagation();
    dispatch(setFavoriteABWorkReportFilter(filter.id, !filter.isFavorite));
  }, [dispatch]);

  return (
    <Drawer
      title="Filters"
      visible={visible}
      onClose={onClose}
      width={1100}
      destroyOnClose
    >
      <Tabs
        activeKey={activeTab}
        tabPosition="left"
        onChange={onTabChange}
        className="filter-drawer-tabs"
        destroyInactiveTabPane
      >
        <TabPane
          tab="Custom View"
          key="custom"
          style={{ marginBottom: 50 }}
        >
          <ABWorkReportFilterTab
            onClose={onClose}
            setActiveTab={setActiveTab}
            columns={columns}
            filters={filters}
            setFilters={setFilters}
          />
        </TabPane>
        {savedFilters.map((filter) => (
          <TabPane
            tab={(
              <span>
                {filter.name}
                {filter.isFavorite ? (
                  <StarFilled
                    style={{ marginLeft: 8, color: '#fdb81b' }}
                    onClick={(e) => onToggleFavorite(e, filter)}
                  />
                ) : (
                  <StarOutlined
                    style={{ marginLeft: 8 }}
                    onClick={(e) => onToggleFavorite(e, filter)}
                  />
                )}
              </span>
            )}
            key={filter.id}
            style={{ marginBottom: 50 }}
          >
            <ABWorkReportFilterTab
              onClose={onClose}
              filterView={filter}
              setActiveTab={setActiveTab}
              columns={columns}
              filters={filters}
              setFilters={setFilters}
            />
          </TabPane>
        ))}
      </Tabs>
    </Drawer>
  );
}

ABWorkReportFilterDrawer.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({})),
};

ABWorkReportFilterDrawer.defaultProps = {
  columns: [],
};
